<template>
    <div>
        <AlertModal
                v-if="controller.alertModal != null"
                :controller="controller.alertModal"
        ></AlertModal>
        <AlertDescription
                v-if="controller.alertDescription != null"
                :controller="controller.alertDescription"
        ></AlertDescription>
        <AlertPointModal
                v-if="controller.alertPointModal != null"
                :controller="controller.alertPointModal"
        ></AlertPointModal>
        <ConfirmModal
                v-if="controller.confirmModal != null"
                :controller="controller.confirmModal"
        ></ConfirmModal>
        <LoadingModal
                v-if="controller.loadingModal != null"
                :controller="controller.loadingModal"
        ></LoadingModal>
        <OtpModal
                v-if="controller.otpModal != null"
                :controller="controller.otpModal"
        ></OtpModal>
        <PdpaModal
                v-if="controller.pdpaModal != null"
                :controller="controller.pdpaModal"
        ></PdpaModal>
        <PdpaRegisterModal
                v-if="controller.pdpaRegisterModal != null"
                :controller="controller.pdpaRegisterModal"
        ></PdpaRegisterModal>
        <ConfirmRedeemModal
                v-if="controller.confirmRedeemModal != null"
                :controller="controller.confirmRedeemModal"
        ></ConfirmRedeemModal>
        <SerialModal
                v-if="controller.serialModal != null"
                :controller="controller.serialModal"
        ></SerialModal>
        <DrawDeliveryModal
                v-if="controller.drawDeliveryModal != null"
                :controller="controller.drawDeliveryModal"
        ></DrawDeliveryModal>
        <ShippingAddressModal
                v-if="controller.shippingAddressModal != null"
                :controller="controller.shippingAddressModal"
        ></ShippingAddressModal>
        <AddAddressModal
                v-if="controller.addAddressModal != null"
                :controller="controller.addAddressModal"
        ></AddAddressModal>
        <EditAddressModal
                v-if="controller.editAddressModal != null"
                :controller="controller.editAddressModal"
        ></EditAddressModal>
        <ListAddressModal
                v-if="controller.listAddressModal != null"
                :controller="controller.listAddressModal"
        ></ListAddressModal>
        <AddTaxAddressModal
                v-if="controller.addTaxAddressModal != null"
                :controller="controller.addTaxAddressModal"
        ></AddTaxAddressModal>
        <EditTaxAddressModal
                v-if="controller.editTaxAddressModal != null"
                :controller="controller.editTaxAddressModal"
        ></EditTaxAddressModal>
        <ListTaxAddressModal
                v-if="controller.listTaxAddressModal != null"
                :controller="controller.listTaxAddressModal"
        ></ListTaxAddressModal>
        <LoginModal
                v-if="controller.loginModal != null"
                :controller="controller.loginModal"
        ></LoginModal>
        <PasswordModal
                v-if="controller.passwordModal != null"
                :controller="controller.passwordModal"
        ></PasswordModal>
        <SuccessModal
                v-if="controller.successModal != null"
                :controller="controller.successModal"
        ></SuccessModal>
        <AlertTransferPointModal
                v-if="controller.alertTranfersPointModal != null"
                :controller="controller.alertTranfersPointModal"
        ></AlertTransferPointModal>
        <ConfirmTransferMAAIModal
                v-if="controller.confirmTransferMAAIModal != null"
                :controller="controller.confirmTransferMAAIModal"
        ></ConfirmTransferMAAIModal>
        <TransferFailModal
                v-if="controller.transferFailModal != null"
                :controller="controller.transferFailModal"
        ></TransferFailModal>
        <ContractCallCenterModal
                v-if="controller.contractCallCenterModal != null"
                :controller="controller.contractCallCenterModal"
        ></ContractCallCenterModal>
    </div>
</template>
<script>
//generic
import AlertModal from './Generic/AlertModal/AlertModal.vue';
import AlertDescription from './Generic/AlertModal/AlertDescription.vue';
import ConfirmModal from "./Generic/ConfirmModal/ConfirmModal.vue";
import LoadingModal from './Generic/LoadingModal/LoadingModal.vue';
import SuccessModal from './Generic/SuccessModal/SuccessModal.vue';
import AlertTransferPointModal from './Generic/AlertModal/AlertTransferPointModal.vue';
//authen
import PdpaModal from './Authen/PdpaModal/PdpaModal.vue';
import PdpaRegisterModal from './Authen/PdpaRegisterModal/PdpaRegisterModal.vue';
import OtpModal from "./Authen/otpModal/OtpModal.vue";
//redeem
import ConfirmRedeemModal from '@/module/Detail/modal/ConfirmRedeemModal/ConfirmRedeemModal.vue';
import SerialModal from '@/module/Detail/modal/SerialModal/SerialModal.vue';
import DrawDeliveryModal from '@/module/Detail/modal/DrawDeliveryModal/DrawDeliveryModal.vue';
import ShippingAddressModal from '@/module/Detail/modal/ShippingAddressModal/ShippingAddressModal.vue';
import AlertPointModal from './Generic/AlertModal/AlertPointModal.vue';
//address
import AddAddressModal from '@/module/Address/DeliveryAddress/modal/AddAddressModal/AddAddressModal.vue';
import EditAddressModal from '@/module/Address/DeliveryAddress/modal/EditAddressModal/EditAddressModal.vue';
import ListAddressModal from '@/module/Address/DeliveryAddress/modal/ListAddressModal/ListAddressModal.vue';
import AddTaxAddressModal from '@/module/Address/TaxAddress/modal/AddTaxAddressModal/AddTaxAddressModal.vue';
import EditTaxAddressModal from '@/module/Address/TaxAddress/modal/EditTaxAddressModal/EditTaxAddressModal.vue';
import ListTaxAddressModal from '@/module/Address/TaxAddress/modal/ListTaxAddressModal/ListTaxAddressModal.vue';
//Tipcoin
import LoginModal from '@/module/Login/modal/LoginModal/LoginModal.vue';
import PasswordModal from '@/module/Login/modal/PasswordModal/PasswordModal.vue';
import ConfirmTransferMAAIModal from '@/module/TransferMAAI/modal/ConfirmTransferMAAIModal/ConfirmTransferMAAIModal.vue';
import TransferFailModal from '@/module/TransferMAAI/modal/TransferFailModal/TransferFailModal.vue';
import ContractCallCenterModal from '@/module/TransferMAAI/modal/ContractCallCenterModal/ContractCallCenterModal.vue'

export default {
    name: 'ModalMaster',
    components: {
        AlertModal,
        AlertDescription,
        AlertPointModal,
        AlertTransferPointModal,
        ConfirmModal,
        LoadingModal,
        OtpModal,
        PdpaModal,
        PdpaRegisterModal,
        ConfirmRedeemModal,
        SerialModal,
        ShippingAddressModal,
        DrawDeliveryModal,
        AddAddressModal,
        EditAddressModal,
        ListAddressModal,
        AddTaxAddressModal,
        EditTaxAddressModal,
        ListTaxAddressModal,
        LoginModal,
        PasswordModal,
        SuccessModal,
        ConfirmTransferMAAIModal,
        TransferFailModal,
        ContractCallCenterModal,
    },
    props: {
        controller: {
            type: Object,
            required: true,
        },
    },
}
</script>
